import { Component, OnInit } from '@angular/core';
import { LectureContentMaster } from '../model/LectureContentMaster.model';
import { LectureMaster } from '../model/LectureMaster.model';
import { MainserviceService } from '../service/mainservice.service';
import Player from '@vimeo/player';
@Component({
  selector: 'app-festival-details',
  templateUrl: './festival-details.component.html',
  styleUrls: ['./festival-details.component.scss']
})

export class FestivalDetailsComponent implements OnInit {
  lectureMaster:LectureMaster = new LectureMaster();
  selectedLectureContentMaster:LectureContentMaster = new LectureContentMaster();
  displayNotPaidMessage:string;
  diplayNoLectureMessage:string;
  lectureMasterSession:LectureMaster = new LectureMaster();
LectureContentList:LectureContentMaster []=[];
player;
  constructor(public mainService:MainserviceService) { }

  ngOnInit() {
  
    this.getStudentLectureMaster();
    this.initPlayer();
    this.playVideo();
  }
  getStudentLectureMaster(){
    
    this.lectureMasterSession = this.mainService.getLectureMasterSession();
    if(this.lectureMasterSession.lectureMasterId != null){
      this.lectureMaster.lectureMasterId = this.lectureMasterSession.lectureMasterId;
      this.mainService.getLectureMasterById(this.lectureMaster).subscribe(data=>{
      this.lectureMaster = data;
     
        this.selectedLectureContent(this.lectureMaster.lectureContentVideosList[0]);
      });
    }
    if(this.lectureMasterSession.errorMessage == "NO-PAID"){
      this.displayNotPaidMessage="Current Month not Paid";
    }
    if(this.lectureMasterSession.errorMessage == "NO-LECTURE"){
      this.diplayNoLectureMessage ="No Lecture For Today";
    }
    // if(this.studentLectureMasterSession.err)
   

  }

  selectedLectureContent(lectureContentMaster:LectureContentMaster){
    
      this.selectedLectureContentMaster = lectureContentMaster;
      if(this.selectedLectureContentMaster.contentMaster!=null && this.selectedLectureContentMaster.contentMaster!=undefined){
        this.setVideo(this.selectedLectureContentMaster.contentMaster.filePath); 
  
      }
  
      this.LectureContentList = [];
  
      this.lectureMaster.lectureContentAssignmentsList.forEach(lectureContent => {
  
      
  
        if( lectureContent.contentMaster != null && lectureContent.contentMaster.predefinedMaster != null &&
          this.selectedLectureContentMaster.contentMaster != null && this.selectedLectureContentMaster.contentMaster.predefinedMaster != null &&
          lectureContent.contentMaster.predefinedMaster.predefinedId == this.selectedLectureContentMaster.contentMaster.predefinedMaster.predefinedId){
          this.LectureContentList.push(lectureContent);
        }
  
      });
  
      this.lectureMaster.lectureContentNotesList.forEach(lectureContent => {
  
        if( lectureContent.contentMaster != null && lectureContent.contentMaster.predefinedMaster != null &&
          this.selectedLectureContentMaster.contentMaster != null && this.selectedLectureContentMaster.contentMaster.predefinedMaster != null &&
          lectureContent.contentMaster.predefinedMaster.predefinedId == this.selectedLectureContentMaster.contentMaster.predefinedMaster.predefinedId){
          this.LectureContentList.push(lectureContent);

        }
  
      });
  
  
    }
    setVideo(videoId: any) {
      // this.destroyPlayer();
      this.initPlayer();
    
      this.player.loadVideo(videoId).then(function (id) {
    
      });
    
    }
    playVideo() {
      setTimeout(() => {
        this.player.play().then(function () {
    
        });
      }, 5000);
    }
    // vimeo player functions
private initPlayer() {
  this.player = new Player('video_iframe', {});
}
private destroyPlayer() {
  this.player.destroy().then(function () {
    // the player was destroyed
  }).catch(function (error) {
    // an error occurred
  });
}
}
